module.exports = __webpack_public_path__ + "images/graphic-header-mobile-2_800664775bf10db64604b9857b1142b3.png";